export const visit = (vm, at) => {
vm(require("foundations-components/lang/he-il.lyaml"));
at({ "he-il": { "placeholder": "\u05DE\u05E6\u05D9\u05D9\u05DF \u05DE\u05D9\u05E7\u05D5\u05DD" } });
};